import loadable from '@loadable/component'

const AddToCartModal = loadable(() => import('./internal'))

export default AddToCartModal
